import React from 'react'
import s from './messenger.module.scss'
import { PageTemplate } from '@shared/ui/page-template'
import { Chat } from '@widgets/messanger/ui/chat/chat/chat'


export const Messenger = () => {
	return (
		<PageTemplate title='Чаты' scrollContentOnMobile whiteOnMobile hideTitleOnTablet hideTitleOnMobile>
			<Chat className={s.chat}/>
		</PageTemplate>
	)
}
